import PrimarySection from "../PrimarySection"
import SecondarySection from "../SecondarySection"

const ResumeComponent = () => {
    return (
        <div className='resume-content-inner'>
            <PrimarySection />
            <SecondarySection />
        </div>
    )
}

export default ResumeComponent